"use strict";

/* global marketingLabelsNameMap */

import { ItemListingState, ItemListingConfig, itemListingConfigModifier } from "./listing-helper";
import ListingCacheHandler from "./listing-cache-handler";
import ListingActionsHandler from "./listing-actions";

class FilterHandler {

	copyState(state, config) {
		this.state = state || ItemListingState;
		this.config = config || ItemListingConfig;
	}


	init(state, config, customHandlers) {

		this.copyState(state, config);
		this.handlers = {};

		const filters = this.getFilterState();
		this.saveFilterState(filters, true);
		this.config.defaultFilterState = filters;

		this.handlers.cacheHandler = ListingCacheHandler;
		//workers.analyticsHelper = ListingAnalyticsHelper;
		//workers.filterHandler = ListingFilterHandler;
		//workers.listeners = ItemListingListenersHandler;
		this.handlers.actions = ListingActionsHandler;

		if (typeof customHandlers === "object" && customHandlers) {
			for (const key of Object.keys(customHandlers)) {
				this.handlers[key] = customHandlers[key];
			}
		}
	}


	getFilterState() {
		const filterItems = document.querySelectorAll(this.config.filterBarItems);

		const checkboxGroups = {};
		const filters = [];

		for (const item of filterItems) {

			const optionId = item.dataset.filter;
			const optionValue = item.dataset.value;
			const optionType = item.dataset.type;
			const checkboxGroup = item.dataset.checkboxGroup;

			if (checkboxGroups[checkboxGroup] === undefined && checkboxGroup) {
				checkboxGroups[checkboxGroup] = { values: [] };
			}

			if (checkboxGroup && Number(optionValue)) {
				checkboxGroups[checkboxGroup].values.push(optionId);
			}

			if (optionValue && !checkboxGroup) {

				//Mobile filters (accordions->fulldropdowns) are actually copied to desktop.
				if (optionType === "fulldropdown") {
					filters.push({ name: optionId, value: JSON.parse(optionValue) });
				} else {
					filters.push({ name: optionId, value: optionValue });
				}

			}

		}

		for (const key of Object.keys(checkboxGroups)) {
			filters.push({ name: key, value: checkboxGroups[key].values });
		}

		const currentFilters = this.getCurrentFilter();
		const trackSelectedGroups = (filters) => {
			const categories = filters.filter(item => item.name === "categories")[0];
			if (categories) {

				if (categories.value.length > 0) {
					this.state.selectedGroups = [];
					for (const selected of categories.value) {
						const foundValue = this.state.selectedGroups.indexOf("og-" + this.handlers.cacheHandler.cache.groupLookup[selected]);
						if (foundValue < 0) {
							this.state.selectedGroups.push("og-" + this.handlers.cacheHandler.cache.groupLookup[selected]);
						}
					}

				} else {
					this.state.selectedGroups = [];
				}

			} else {
				this.state.selectedGroups = [];
			}

		};
		trackSelectedGroups(filters);
		currentFilters.filters = filters;

		return currentFilters;
	}

	getCurrentFilter() {

		const filters = JSON.parse(this.config.filterBar.getAttribute(this.config.filterDataSelector));
		if (filters.filters !== undefined && Array.isArray(filters.filters)) {
			for (const item of this.config.additionalFilters) {
				filters.filters.push(item);
			}

		}

		return filters;
	}

	updateFilterState() {
		this.saveFilterState(this.getFilterState());
	}

	/**
	 * Checks selected/active filters and does some extra actions accoringly. 
	 * 
	 * @param {object} filters - Selected/active filters.
	 */
	dynamicFilterActions(filters) {
		if (Array.isArray(filters)) {

			for (const filter of filters) {

				switch (filter.name) {
					// At the moment used only for budjettipäivät & synttärit.
					case "marketingLabels": {

						const valueMap = marketingLabelsNameMap ? marketingLabelsNameMap : {};

						for (const fbtElement of this.config.filterBarText) {

							if (Array.isArray(filter.value)) {

								const labels = filter.value.slice().map(label => {
									if (valueMap[label]) {
										if (filter.value.length === 1) {
											return valueMap[label].long;
										} else {
											return valueMap[label].short;
										}
									} else {
										return label;
									}
								});

								let defaultText = fbtElement.textContent;

								if (fbtElement.dataset.barText) {
									defaultText = fbtElement.dataset.barText;
								}

								if (labels.length <= 2 && labels.length > 0) {
									fbtElement.textContent = String(defaultText + " - " + labels.join(" ja ")).trim();
								} else if (labels.length >= 3) {
									const last = " ja " + labels.pop();
									fbtElement.textContent = String(defaultText + " - " + labels.join(", ") + last).trim();
								} else {
									fbtElement.textContent = defaultText;
								}
							}
						}
						break;
					}
				}
			}
		}
	}

	saveFilterState(filters, doSkipFetch) {

		this.dynamicFilterActions(filters.filters);

		this.state.skipFetch = (doSkipFetch) ? true : false;

		const uniqBy = (a, key) => {
			const seen = {};
			return a.filter(function (item) {
				const k = key(item);
				return seen[k] !== undefined ? false : (seen[k] = true);
			});
		};

		filters.filters = uniqBy(filters.filters, JSON.stringify);

		const tempObj = {};

		for (let i = 0; i < filters.filters.length; i++) {
			const filter = filters.filters[i];
			if (filter.name === "options") {
				if (filter.value.length > 0) {

					for (const value of filter.value) {

						if (value.indexOf("|:|") > 0) {
							const val = value.split("|:|");
							const optionGroup = val[0];
							const optionValue = val[1];

							if (tempObj[optionGroup] === undefined) {
								tempObj[optionGroup] = [];
							}
							tempObj[optionGroup].push(optionValue);
						} else {
							if (tempObj.features === undefined) {
								tempObj.features = [];
							}
							//Is feature
							tempObj.features.push(value);

						}
					}

				}

				filters.filters.splice(i, 1);
				i--;

			}
		}

		for (const key of Object.keys(tempObj)) {
			const element = tempObj[key];
			filters.filters.push({
				name: key,
				value: element
			});
		}

		this.config.filterBar.setAttribute(this.config.filterDataSelector, JSON.stringify(filters));
	}

	getViewState(isMobile) {

		const selector = isMobile ? this.config.mobileFilterBarSelector + " .accordion-visible" : ".bar-dropdown-view";
		const viewItems = document.querySelectorAll(selector + " [data-filter]");

		const viewSettings = {
			filter: document.querySelector(selector).dataset.filter,
			values: []
		};

		for (const item of viewItems) {

			const optionId = item.dataset.id;
			const optionValue = item.dataset.value;

			if (optionValue && Number(optionValue)) {
				viewSettings.values.push(optionId);
			}

		}

		return viewSettings;
	}

	restoreView(view) {
		let viewFilters = view.dataset.value;
		if (viewFilters) {
			viewFilters = JSON.parse(viewFilters);

			const checkCheckboxes = (checkboxes) => {

				for (const element of checkboxes) {

					element.dataset.value = 1;
					element.classList.add("checked");
					const ariaCheckbox = element.querySelector("[role=\"checkbox\"]");
					if (ariaCheckbox) {
						ariaCheckbox.setAttribute("aria-checked", "true");
					}
				}
			};

			for (const value of viewFilters) {
				checkCheckboxes(document.querySelectorAll(".component[data-id=\"" + value + "\"]"));
			}

			const optionGroups = document.querySelectorAll(".view .options .option-group");
			for (const og of optionGroups) {

				const tickedFilter = og.querySelector("ul .checked");
				if (tickedFilter) {
					checkCheckboxes(og.querySelectorAll(".option-header .component-checkbox"));
				}

			}

		}

		if (this.state.selectedGroups.length > 0) {

			const sizeGroups = document.querySelectorAll("[data-filter=\"sizes\"] .option-group");
			for (const group of sizeGroups) {
				if (this.state.selectedGroups.indexOf(group.dataset.group) < 0) {
					group.parentNode.removeChild(group);
				}
			}
		}

	}



	saveViewState(viewSettings) {

		const fid = viewSettings.filter;
		const filters = document.querySelectorAll(this.config.filterBarSelector + " .filter-bar-main-settings .component[data-filter=\"" + fid + "\"], " + this.config.mobileFilterBarSelector + " .component[data-filter=\"" + fid + "\"]");
		delete viewSettings.filter;
		let optionsAccordion = false;
		let optionsView = false;

		for (const filter of filters) {
			const source = filter.dataset.source;
			optionsAccordion = filter.dataset.options === "true" && filter.dataset.type === "accordion";
			optionsView = filter.dataset.filter === "options" && (filter.dataset.type === "accordion" || filter.dataset.type === "fulldropdown");

			if (viewSettings.values.length > 0) {

				const values = viewSettings.values;

				const selected = [];
				const validValues = [];
				for (const val of values) {
					if (optionsAccordion) {
						const optionsVal = this.handlers.cacheHandler.cache.dataSourceById["options"][val];
						if (optionsVal !== undefined) {
							validValues.push(val);
							selected.push(optionsVal);
						}
					} else {
						if (this.handlers.cacheHandler.cache.dataSourceById[source] !== undefined && this.handlers.cacheHandler.cache.dataSourceById[source][val] !== undefined) {
							validValues.push(val);
							selected.push(this.handlers.cacheHandler.cache.dataSourceById[source][val].name);
						}
					}
				}

				filter.dataset.value = JSON.stringify(validValues);
				filter.dataset.selected = JSON.stringify(selected);

			} else {
				filter.dataset.selected = "";
				filter.dataset.value = "";
			}
		}

		if (optionsAccordion) {
			this.handlers.actions.handleAccordionOptions();
		}

		if (optionsView) {
			this.handlers.actions.restoreOptionsAccordionValues();
		}

	}

	restoreFilters(filters) {

		this.dynamicFilterActions(filters.filters);

		const filterItems = document.querySelectorAll(this.config.filterBarSelector + " .component, " + this.config.mobileFilterBarSelector + " .component");

		const getDropdownName = (filterId, optionId) => {
			const currentDataSource = this.state.dataSourceWorkset[filterId];
			if (currentDataSource) {
				for (const key of Object.keys(currentDataSource)) {
					const option = currentDataSource[key];
					if (option.option === optionId) {
						return option.name;
					}
				}
			} else {
				return filterId;
			}
		};

		const filterValues = filters.filters;
		const filterValuesObject = {};

		for (const val of filterValues) {
			filterValuesObject[val.name] = val.value;
		}

		for (const element of filterItems) {

			const elementType = element.dataset.type;

			const filterId = element.dataset.filter;
			const checkboxGroup = element.dataset.checkboxGroup;
			if (checkboxGroup) {

				const storedValues = filterValuesObject[checkboxGroup];
				if (storedValues && filterValuesObject[checkboxGroup].indexOf(filterId) > -1) {
					element.classList.add("checked");
					element.dataset.value = 1;
					const ariaCheckbox = element.querySelector("[role=\"checkbox\"]");
					if (ariaCheckbox) {
						ariaCheckbox.setAttribute("aria-checked", "true");
					}

				} else {
					element.classList.remove("checked");
					element.dataset.value = 0;
					const ariaCheckboU = element.querySelector("[role=\"checkbox\"]");
					if (ariaCheckboU) {
						ariaCheckboU.setAttribute("aria-checked", "false");
					}
				}
			} else {

				const storedValues = filterValuesObject[filterId];

				switch (elementType) {

					case "checkbox":
						if (storedValues) {
							element.dataset.value = JSON.stringify(storedValues);
							if (Number(storedValues)) {
								element.classList.add("checked");
								element.dataset.value = 1;
								const ariaCheckbox1 = element.querySelector("[role=\"checkbox\"]");
								if (ariaCheckbox1) {
									ariaCheckbox1.setAttribute("aria-checked", "true");
								}
							} else {
								element.classList.remove("checked");
								element.dataset.value = 0;
								const ariaCheckbox2 = element.querySelector("[role=\"checkbox\"]");
								if (ariaCheckbox2) {
									ariaCheckbox2.setAttribute("aria-checked", "true");
								}
							}

						}
						break;
					case "accordion":
					case "fulldropdown":
						if (storedValues && storedValues.length > 0) {
							const source = element.dataset.source;
							const selected = [];
							const validValues = [];

							for (const val of storedValues) {
								if (this.handlers.cacheHandler.cache.dataSourceById[source] !== undefined && this.handlers.cacheHandler.cache.dataSourceById[source][val] !== undefined) {
									validValues.push(val);
									selected.push(this.handlers.cacheHandler.cache.dataSourceById[source][val].name);
								}
							}

							element.dataset.value = JSON.stringify(validValues);
							element.dataset.selected = JSON.stringify(selected);

						} else {
							element.dataset.value = "";
							element.dataset.selected = "";
						}

						if (elementType === "accordion") {
							element.classList.remove("accordion-visible");
							element.querySelector(".view-wrapper").style.height = "";
							const labelAdditions = element.querySelector(".label-additions");
							if (labelAdditions) {
								labelAdditions.textContent = "";
							}
						}
						break;

					case "dropdown":
						if (storedValues) {
							element.dataset.value = storedValues;
							const selectedOptions = element.querySelector(".component-label, .selected-options");
							if (selectedOptions) {
								selectedOptions.textContent = getDropdownName(filterId, storedValues);
							}
						}
						break;

					default:
						break;
				}

			}
		}

		this.handlers.actions.handleAccordionOptions();
		this.handlers.actions.restoreOptionsAccordionValues();

	}

	saveToSessionStorage() {
		const listing = document.querySelector(this.config.listingSelector).innerHTML;
		const filters = this.config.filterBar ? this.config.filterBar.getAttribute(this.config.filterDataSelector) : {};

		if (listing && sessionStorage && history) {
			const totalProductCount = this.handlers.actions.getItemCount();
			const options = document.querySelector(this.config.filterBarSelector + " .component[data-filter=\"options\"]");

			sessionStorage.setItem(this.config.sessionStorageKey, btoa(encodeURI(JSON.stringify({
				index: ItemListingState.currentIndex,
				promoItemCounters: ItemListingState.promoItemCounters,
				nextPage: ItemListingState.nextPage,
				totalProductCount: totalProductCount ? totalProductCount : 0,
				filters: filters,
				options: options ? { value: options.dataset.value || "", selected: options.dataset.selected || "" } : { value: "", selected: "" },
				selectedGroups: ItemListingState.selectedGroups,
				markup: listing,
				done: ItemListingState.done
			}))));
			history.replaceState("", null, this.config.sessionStorageUrlHash);
		}
	}

	restoreFromSessionStorage() {
		if (location.hash === this.config.sessionStorageUrlHash && sessionStorage && sessionStorage.getItem(this.config.sessionStorageKey) && history) {
			this.state.lazyLoadCounter = this.state.lazyLoadingTimes + 1; // Must click load more after returning.
			const stored = JSON.parse(decodeURI(atob(sessionStorage.getItem(this.config.sessionStorageKey))));
			this.state.currentIndex = stored.index;
			this.state.promoItemCounters = stored.promoItemCounters;
			document.querySelector(this.config.listingSelector).innerHTML = stored.markup;
			this.handlers.actions.setNextPage(stored.nextPage);

			this.handlers.actions.updateListingCount(stored.totalProductCount || stored.totalItemCount);

			if (stored.done) {
				this.config.itemListingActions.classList.add("done");
			}
			this.state.selectedGroups = stored.selectedGroups;

			this.restoreFilters(JSON.parse(stored.filters));
			const options = document.querySelectorAll(this.config.filterBarSelector + " .component[data-filter=\"options\"]");
			for (const option of options) {
				option.dataset.value = stored.options.value;
				option.dataset.selected = stored.options.selected;
			}

			this.handlers.actions.restoreOptionsAccordionValues();

			this.config.filterBar.setAttribute(this.config.filterDataSelector, stored.filters);

			history.replaceState("", null, this.config.sessionStorageKey + location.search); // Remove hash from url
		}

	}

	loadFilterSet() {
		const filters = this.getCurrentFilter();

		if (filters !== undefined && Array.isArray(filters.loadFilters)) {

			const pageFilterLookup = {};
			const filterElements = document.querySelectorAll(this.config.filterBarSelector + " .filter-bar-main-settings *[data-filter]");

			for (const filterElement of filterElements) {
				if (filterElement.dataset.checkboxGroup) {
					pageFilterLookup[filterElement.dataset.checkboxGroup] = true;
				} else {
					pageFilterLookup[filterElement.dataset.filter] = true;
				}
			}

			for (const loadFilter of filters.loadFilters) {
				if (!pageFilterLookup[loadFilter.name]) {
					this.config.additionalFilters.push(loadFilter);
				}
			}

			this.restoreFilters({ filters: filters.loadFilters });
			delete filters.loadFilters;
			this.saveFilterState(this.getFilterState(), true);
		}
	}
}

export default new FilterHandler();
